/* eslint-disable no-unexpected-multiline */
import React, {useState} from 'react'
import {connect} from 'react-redux'
import {storePayload} from '../actions/storePayload'
import {changeQuestion} from '../actions/changeQuestion2'
import FormFooter from './FormFooter'
import '../styles/ResponseReview.css'

function ResponseReview(props) {
  const {
    prompt1Response,
    localPrompt1Response,
    selectedSectionName,
    selectedSubSectionName,
    currentPqId,
    currentPqIdIndex,
    currentUfqIdIndex,
    selectedSectionIndex,
    selectedSubSectionIndex,
  } = props

  // eslint-disable-next-line no-unused-vars
  const [time, setTime] = useState(null)
  function onClickChat() {
    props.storePayload({
      isChatShowing: !props.isChatShowing,
    })
  }

  function onChangeResponse(e) {
    const newPrompt1Response = prompt1Response
    const newLocalPrompt1Response = localPrompt1Response
    newPrompt1Response
        [selectedSectionName]
        [selectedSubSectionName]
        ['Response'] = e.target.value
    newLocalPrompt1Response
        [selectedSectionName]
        [selectedSubSectionName]
        ['Response'] = e.target.value
    console.log(
        'storing new response',
        newPrompt1Response
            [selectedSectionName]
            [selectedSubSectionName]
            ['Response'],
    )

    const newTime = Date.now()
    props.storePayload({
      prompt1Response: newPrompt1Response,
      localPrompt1Response: localPrompt1Response,
      time: newTime,
    })
    setTime(newTime)
  }

  function onClickBtn1() {
    if (props.isSectionReadyForReview) {
      props.storePayload({
        typeFormStep: 'section-review',
      })
    } else {
      console.log('To do: handle btn1 click')
      const changeQuestionProps = {
        newSubSectionIndex: selectedSubSectionIndex + 1,
        newPqIdIndex: currentPqIdIndex + 1,
        newUfqIdIndex: currentUfqIdIndex + 1,
        currentPqId,
        currentPqIdIndex,
        currentUfqIdIndex,
        prompt1Response,
        selectedSectionIndex,
        selectedSubSectionIndex,
        selectedSectionName,
        selectedSubSectionName,
        // even though it is review, currently skip is prevented
        isReview: false,
        isSubSectionReadyForReview: false,
      }
      props.changeQuestion(changeQuestionProps)
      props.storePayload({
        typeFormStep: 'typeform',
      })
    }
  }

  return (
    <div id='response-review'>
      <header>
        <span className='span-h2'>
          {`${selectedSectionIndex + 1}.${selectedSubSectionIndex + 1} `}
        </span>
        <span className='span-h2'>
          {selectedSubSectionName}
        </span>
        <p>Based on your answers, Alfred has generated the following:</p>
      </header>
      <main>
        <div className={'text-area-wrapper'}>
          <div
            className={'typeform-input invisible-text-area'}
            id={`invisible-text-area`}
          >
            {
              prompt1Response
                  [selectedSectionName]
                  [selectedSubSectionName]
                  ['Response']
            }
          </div>
          <textarea
            placeholder={'Type your answer here...'}
            onChange={onChangeResponse}
            name='newPrompt'
            value={
              prompt1Response
                  [selectedSectionName]
                  [selectedSubSectionName]
                  ['Response']
            }
            rows={1}
            // form={formId}
            className={'typeform-input custom-txt-area'}
            // eslint-disable-next-line max-len
            id={`input`}
          />
        </div>
      </main>
      <FormFooter
        btn1Text='Accept & Continue'
        onClickBtn1={onClickBtn1}
        onClickChat={onClickChat}
        onClickArrowUp={null}
        onClickArrowDown={null}
        theme={props.theme}
        style={{
          left: 'calc(2.625em + 20px)',
          width: 'calc(100% - (2.625em + 20px))',
          padding: 'var(--spacing-06, 24px) 20px',
        }}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  selectedSectionIndex: state.userReducer.selectedSectionIndex,
  selectedSectionName: state.userReducer.selectedSectionName,
  selectedSubSectionIndex: state.userReducer.selectedSubSectionIndex,
  selectedSubSectionName: state.userReducer.selectedSubSectionName,
  selectedPath: state.userReducer.selectedPath,
  prompt1Response: state.userReducer.prompt1Response,
  currentPqId: state.userReducer.currentPqId,
  currentUfqId: state.userReducer.currentUfqId,
  currentPqIdIndex: state.userReducer.currentPqIdIndex,
  currentUfqIdIndex: state.userReducer.currentUfqIdIndex,
  time: state.userReducer.time,
  localPrompt1Response: state.userReducer.localPrompt1Response,
  isSubSectionReadyForReview: state.userReducer.isSubSectionReadyForReview,
  isSectionReadyForReview: state.userReducer.isSectionReadyForReview,
  isChatShowing: state.userReducer.isChatShowing,
  isReview: state.userReducer.isReview,
  isSkip: state.userReducer.isSkip,
})

export default connect(
    mapStateToProps,
    {storePayload, changeQuestion},
)(ResponseReview)
